import { createSlice } from "@reduxjs/toolkit";

const xmlSlice = createSlice({
  name: "xml",
  initialState: [],
  reducers: {
    xmlAdded(state, action) {
      return action.payload;
    },
  },
});

export const { xmlAdded } = xmlSlice.actions;
export default xmlSlice.reducer;
